import { render, staticRenderFns } from "./Ticket-card-home.vue?vue&type=template&id=bc18ecec&scoped=true"
import script from "./Ticket-card-home.vue?vue&type=script&lang=js"
export * from "./Ticket-card-home.vue?vue&type=script&lang=js"
import style0 from "./Ticket-card-home.vue?vue&type=style&index=0&id=bc18ecec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc18ecec",
  null
  
)

export default component.exports